import type { SwitchRootProps } from '@base-ui/react';

import { Switch as BaseSwitch } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { contentStyle, fieldItemStyle, rootStyle, thumbStyle } from './SwitchRoot.css';

type Props = SwitchRootProps;

export const SwitchRoot = ({ children, ...delegated }: Props) => {
  return (
    <label className={fieldItemStyle}>
      <BaseSwitch.Root {...delegated} className={clsxs(rootStyle, delegated.className)}>
        <BaseSwitch.Thumb className={thumbStyle} />
      </BaseSwitch.Root>

      {children && <div className={contentStyle}>{children}</div>}
    </label>
  );
};
